import { Box, useTheme, IconButton, Typography, useMediaQuery, Chip, Divider } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Close as CloseIcon } from '@mui/icons-material';

import { CustomModalAnimated } from 'src/components/modal-animated';
import { EScanNetwork, IImpactConsumerScanItem } from 'src/types';
import { COLORS } from 'src/styles/common';
import { formatDate, getScanExplorerTxUrl } from 'src/utils';
import { ExternalLinkIcon } from 'src/assets/icons/v2/ExternalLinkIcon';

interface IProps {
  open: boolean;
  handleClose: () => void;
  data: IImpactConsumerScanItem[];
  aiVerifiedCount: number;
}

export const AIVerifiedModal = ({ open, handleClose, data = [], aiVerifiedCount }: IProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const copyToClipboard = (value: string) => {
    navigator.clipboard.writeText(value);
  };

  return (
    <CustomModalAnimated
      ariaLable="modal-ai-verified"
      open={open}
      handleClose={handleClose}
      sx={{
        width: '100dvw'
      }}>
      
      <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l35"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxHeight: '100%'
      }}>
        
        <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l43"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '650px'
        }}>
          
          <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l54"
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 102,
            width: '100%',
            backgroundColor: theme.palette.background.paper
          }}>
            
            <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l63"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px',
              padding: '32px 32px 20px',
              boxSizing: 'border-box'
            }}>
              
              <Typography id="index__components-ai-verified-banner-ai-verified-modal__typography__l73"
              variant="h6"
              sx={{ textAlign: 'center', fontSize: isMobile ? '18px' : '24px' }}>
                
                {'AI Verified'}
              </Typography>
              <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l79"
              sx={{
                width: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                
                <Chip id="index__components-ai-verified-banner-ai-verified-modal__chip__l87"
                size="medium"
                className="count-chip"
                sx={{
                  width: 'auto',
                  height: '35px',
                  borderRadius: '17.5px',

                  display: 'flex',
                  textAlign: 'center',
                  backgroundColor: theme.palette.common.white,
                  border: `2.5px solid ${theme.palette.primary.main}`,
                  color: theme.palette.primary.main,
                  '.MuiChip-label': {

                    // p: '0px',
                  } }}
                label={
                <Typography id="index__components-ai-verified-banner-ai-verified-modal__typography__l105" sx={{ fontSize: '16px', fontWeight: 600 }}>
                      {aiVerifiedCount}
                    </Typography>
                } />
                
              </Box>
            </Box>
            <Divider id="index__components-ai-verified-banner-ai-verified-modal__divider__l112" sx={{ borderColor: 'rgba(0,0,0,0.08);', width: '100%' }} />
          </Box>
          <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l114"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            maxHeight: 'calc(100dvh - 110px)',
            overflowY: 'auto',
            gap: '12px',
            pb: '30px',
            boxSizing: 'border-box'
          }}>
            
            {data.map((item) =>
            <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l129" sx={{ width: '100%', maxWidth: '100%', px: '20px', boxSizing: 'border-box' }}>
                <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l130"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                justifyContent: 'space-between',
                width: '100%'
              }}>
                
                  <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l139"
                sx={{
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: '6px',
                  maxWidth: 'calc(100% - 60px)',
                  justifyContent: 'start'
                }}>
                  
                    <Typography id="index__components-ai-verified-banner-ai-verified-modal__typography__l148"
                  sx={{
                    fontSize: '14px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: COLORS.GREY_LIGHT
                  }}>
                    
                      {isMobile ?
                    <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l158" sx={{ display: 'flex', alignItems: 'center' }}>
                          <Typography id="index__components-ai-verified-banner-ai-verified-modal__typography__l159"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}>
                        
                            {item.user_tx_decrypted.slice(0, -4)}
                          </Typography>

                          <Typography id="index__components-ai-verified-banner-ai-verified-modal__typography__l169" sx={{ ml: '-3px' }}>
                            {item.user_tx_decrypted.slice(-4)}
                          </Typography>
                        </Box> :

                    item.user_tx_decrypted
                    }
                    </Typography>
                  </Box>
                  <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l178"
                sx={{
                  display: 'flex',
                  gap: '2px',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  
                    <IconButton id="index__components-ai-verified-banner-ai-verified-modal__iconbutton__l186"
                  component="a"
                  href={getScanExplorerTxUrl(item.user_tx_decrypted, EScanNetwork.BASE)}
                  target="_blank"
                  sx={{ p: '3px', width: '26px', boxSizing: 'border-box' }}>
                    
                      <ExternalLinkIcon size={20} color={COLORS.GREY_LIGHT} />
                    </IconButton>
                    <IconButton id="index__components-ai-verified-banner-ai-verified-modal__iconbutton__l194"
                  onClick={() => copyToClipboard(item.user_tx_decrypted)}
                  size="small"
                  sx={{ p: '3px', width: '26px', boxSizing: 'border-box' }}>
                    
                      <ContentCopyIcon
                      sx={{ fill: COLORS.GREY_LIGHT, width: '18px', height: '18px' }} />
                    
                    </IconButton>
                  </Box>
                </Box>
                <Box id="index__components-ai-verified-banner-ai-verified-modal__box__l205" sx={{ fontSize: '11px', color: COLORS.GREY_LIGHT, fontWeight: 600 }}>
                  {formatDate(item.approved_on)}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <IconButton id="index__components-ai-verified-banner-ai-verified-modal__iconbutton__l213"
      onClick={handleClose}
      sx={{
        position: 'fixed',
        top: 4,
        right: 8,
        zIndex: 103,
        color: theme.palette.common.black
      }}>
        
        <CloseIcon />
      </IconButton>
    </CustomModalAnimated>);

};